export var Permissions;
(function (Permissions) {
    Permissions["CALL_CAMPAIGNS_VIEW"] = "cc-config.call-campaigns";
    Permissions["CALL_QUEUES_VIEW"] = "cc-config.call-queues";
    Permissions["CHAT_QUEUES_VIEW"] = "cc-config.chat-queues.view";
    Permissions["FLAGS_VIEW"] = "cc-config.flags";
    Permissions["GENERAL_SETTINGS_VIEW"] = "cc-config.settings";
    Permissions["OVERVIEW_VIEW"] = "cc-config.overview";
    Permissions["USERS_VIEW"] = "cc-config.users";
    Permissions["VIEW_AGENT_PAGE"] = "cc-agent";
    Permissions["VIEW_CONTACT_CENTER_ADMIN_CONFIGURATION_PAGE"] = "cc-config";
    Permissions["VIEW_REPORTING_PAGE"] = "unified-analytics.portal";
    Permissions["VIEW_SUPERVISOR_PAGE"] = "cc-supervisor";
    Permissions["VIEW_FREE_TRIAL_ELIGIBILITY_BANNER"] = "cc-config.free-trial-eligibility";
    Permissions["SMART_RESPONSES_VIEW"] = "cc-config.smart-responses";
    Permissions["SURVEYS_VIEW"] = "cc-config.surveys";
    Permissions["ENGAGEMENTS_SETTINGS_GENERAL"] = "engagements.settings.general";
    Permissions["CALL_REPORTS"] = "call-reports";
    Permissions["IMPORT_CONTACTS"] = "contact.import";
    Permissions["MANAGE_CONTACTS_GROUP"] = "contact.group";
    Permissions["MANAGE_CONTACTS_SEGMENTS"] = "contact.segment";
    Permissions["EDIT_CUSTOM_FIELDS"] = "contact.customfield.edit";
    Permissions["GOTO_ENGAGEMENT_LICENSE"] = "engagements";
    Permissions["SEND_CAMPAIGN"] = "engagements.campaigns.add";
    Permissions["ENGAGEMENTS_SETTINGS"] = "engagements.settings";
    Permissions["ENGAGEMENTS_SHARED_INBOX"] = "engagements.shared-inbox";
})(Permissions || (Permissions = {}));
//# sourceMappingURL=contactCenterUserContext.js.map